export default function ChatgptRoles() {
  return <h2>Chatgpt Roles</h2>;
}
